import Image from "@/components/AppImage";
import how_works_icon_1 from "/public/img/how-works-icon-1.png";
import how_works_icon_2 from "/public/img/how-works-icon-2.png";
import how_works_icon_3 from "/public/img/how-works-icon-3.png";

const HowItsWork = () => {
  return (
    <section className="how-works inner-how-works index4">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-7">
              <div className="section-header text-center">
                <h2 className="title">How ACH & wire payouts work</h2>
                <p>
                  Verify your business profile, add beneficiary bank details, and
                  release each transfer with a full audit trail.
                </p>
              </div>
            </div>
          </div>
          <div className="row cus-mar">
            <div className="col-lg-4 col-md-4">
              <div className="single-item d-grid justify-content-center">
                <div className="icon">
                  <div className="iconbg">
                    <Image src={how_works_icon_1} alt="icon" />
                    <span className="xlr">01</span>
                  </div>
                </div>
                <div className="bottom-icon">
                  <h5>Create an acccount</h5>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="single-item second d-grid justify-content-center">
                <div className="icon">
                  <div className="iconbg">
                    <Image src={how_works_icon_2} alt="icon" />
                    <span className="xlr second">02</span>
                  </div>
                </div>
                <div className="bottom-icon">
                  <h5>Add bank instructions</h5>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="single-item d-grid justify-content-center">
                <div className="icon">
                  <div className="iconbg">
                    <Image src={how_works_icon_3} alt="icon" />
                    <span className="xlr third">03</span>
                  </div>
                </div>
                <div className="bottom-icon">
                  <h5>Confirm &amp; track</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItsWork;
